import { render } from "./ShoppingCart.vue?vue&type=template&id=25a38d63&scoped=true"
import script from "./ShoppingCart.vue?vue&type=script&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&lang=js"

import "./ShoppingCart.vue?vue&type=style&index=0&id=25a38d63&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a38d63"]])

export default __exports__